import React from 'react';

const STAGES = ['Preparing', 'Validating', 'Uploading', 'Finalizing'];

const UploadProgressCard = ({
  title = 'Processing file',
  stageIndex = 0,
  stageLabel = 'Preparing',
  helperText = 'Please keep this window open.',
  percent = 0,
  indeterminate = false,
}) => {
  const safePercent = Math.max(0, Math.min(100, Math.round(percent || 0)));

  return (
    <div className="upload-progress-card" role="status" aria-live="polite">
      <div className="upload-progress-card__header">
        <div>
          <h4 className="upload-progress-card__title">{title}</h4>
          <p className="upload-progress-card__subtitle">{stageLabel}</p>
        </div>
        <span className="upload-progress-card__percent">{safePercent}%</span>
      </div>

      <div
        className={`upload-progress-card__bar ${indeterminate ? 'is-indeterminate' : ''}`}
        aria-label="Upload progress"
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={safePercent}
        role="progressbar"
      >
        <span className="upload-progress-card__fill" style={{ width: `${safePercent}%` }} />
      </div>

      <div className="upload-progress-card__steps">
        {STAGES.map((step, index) => {
          const state = index < stageIndex ? 'done' : index === stageIndex ? 'active' : 'idle';
          return (
            <div key={step} className={`upload-progress-card__step is-${state}`}>
              <span className="upload-progress-card__dot" />
              <span>{step}</span>
            </div>
          );
        })}
      </div>

      <p className="upload-progress-card__helper">{helperText}</p>
    </div>
  );
};

export default UploadProgressCard;
